import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { SignFormContext } from '#src/app/pages/petitionDetails/shared/contexts';

type Props = {
	insideMobileModal: boolean;
};

export const SignFormContextProvider: React.FC<PropsWithChildren<Props>> = ({ insideMobileModal, children }) => {
	const value = useMemo(() => ({ insideMobileModal }), [insideMobileModal]);

	return <SignFormContext.Provider value={value}>{children}</SignFormContext.Provider>;
};
